import React, { useImperativeHandle, useRef, useState } from "react";
import styles from './DropdownButton.module.scss'
import { PortalContainer } from "uxp/components";

export interface ICustomDropdownButtonProps {
    content: React.ReactNode
    children: React.ReactNode
}

export interface ICustomDropdownButtonInstanceProps {
    close: () => void
}

export const CustomDropDownButton: React.ForwardRefExoticComponent<React.RefAttributes<ICustomDropdownButtonInstanceProps> & ICustomDropdownButtonProps> = React.forwardRef((props, ref) => {

    const [show, setShow] = useState(false)
    const [dropdownStyles, setDropdownStyles] = useState<React.CSSProperties>({})

    const buttonRef = useRef<HTMLDivElement>(null)

    useImperativeHandle(ref, () => ({
        close: () => setShow(false)
    }))

    function handleClick() {
        if (!buttonRef.current) return
        const bounds = buttonRef.current.getBoundingClientRect()
        if (!bounds) return

        setDropdownStyles({
            top: bounds.y + bounds.height + 10,
            right: document.body.clientWidth - bounds.right
        })

        setShow(true)
    }

    return <React.Fragment>

        <div className={styles.dropdownButtonContainer} onClick={handleClick} ref={buttonRef} >
            {props.children}
        </div>

        {show ?
            <PortalContainer hasBackdrop={true} onClickBackdrop={() => setShow(false)} >
                <div className={styles.dropdownContentContainer} style={dropdownStyles} >
                    {props.content}
                </div>
            </PortalContainer>
            : null}

    </React.Fragment>
})